import i18n from "i18next";
import k from "src/i18n/keys";

import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import FormContainerWithLogo from "src/components/auth/FormContainerWithLogo";
import Loader from "src/components/Loader";
import * as atypes from "src/constants/actionTypes";
import firebase from "firebase/app";
import "firebase/auth";
import { Text } from "@chakra-ui/react";
import * as colors from "src/styles/constants/colors";

function MobileSignin() {
  const dispatch = useDispatch();
  const [error, setError] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const tenantId = params.get("tenantId");
    const provider = params.get("provider");

    const initialLoad = sessionStorage.getItem("initialLoad");

    if (tenantId && provider && !initialLoad) {
      dispatch({
        type: atypes.GET_AUTH_PROVIDER_SUCCESS,
        payload: {
          tenantId,
          provider,
        },
      });
      sessionStorage.setItem("initialLoad", "true");
    }

    firebase
      .auth()
      .getRedirectResult()
      .then((userCredential) => {
        const data = {
          credential: userCredential.credential,
        };
        window.ReactNativeWebView.postMessage(JSON.stringify(data));
      })
      .catch((e) => {
        console.error(e);
        setError(e);
      });
  }, []);

  return (
    <FormContainerWithLogo>
      {!error ? (
        <Loader />
      ) : (
        <Text sx={{ alignSelf: "center", color: colors.brightLight }}>
          {`${i18n.t(k.UNABLE_TO_LOGIN)} ${error}`}
        </Text>
      )}
    </FormContainerWithLogo>
  );
}

export default MobileSignin;
